type MetaEventName = 'Lead' | 'InitiateCheckout'

type MetaPixelFunction = {
  (...args: unknown[]): void
  queue: unknown[][]
  loaded?: boolean
  version?: string
}

declare global {
  interface Window {
    fbq?: MetaPixelFunction
  }
}

const PIXEL_ID = '2832673310418578'
let hasInitialized = false

export function initializeMetaPixel() {
  if (hasInitialized || typeof window === 'undefined') {
    return
  }

  let fbq = window.fbq

  if (!fbq) {
    const queuedPixel = ((...args: unknown[]) => {
      queuedPixel.queue.push(args)
    }) as MetaPixelFunction
    queuedPixel.queue = []
    fbq = queuedPixel
  }

  window.fbq = fbq
  fbq.loaded = true
  fbq.version = '2.0'
  fbq('init', PIXEL_ID)
  fbq('track', 'PageView')

  if (!document.querySelector(`script[data-meta-pixel-id="${PIXEL_ID}"]`)) {
    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    script.dataset.metaPixelId = PIXEL_ID
    document.head.appendChild(script)
  }

  hasInitialized = true
}

export function trackMetaEvent(eventName: MetaEventName) {
  window.fbq?.('track', eventName)
}
